import ToogleSwitch from '../../../../atoms/ToogleSwitch';
import { CollectionAgreement, CollectionOrderStep } from '../collectionAgreementModel';
import { policyHasPhase } from '../agreementAccountRules';
import { CollectionPolicy, OBLIGOR_LABEL, overdueLabel, preventiveLabel } from '../collectionModel';

interface CollectionOrderTableProps {
    agreement: CollectionAgreement;
    policy: CollectionPolicy;
    onChange: (agreement: CollectionAgreement) => void;
}

const ROLE_LABEL: Record<CollectionOrderStep['role'], string> = { ...OBLIGOR_LABEL, PAYER: 'Sacado', GUARANTOR: 'Avalistas' };

const CollectionOrderTable = ({ agreement, policy, onChange }: CollectionOrderTableProps) => {
    const hasPreventive = policyHasPhase(policy, 'preventive');
    const hasOverdue = policyHasPhase(policy, 'overdue');
    const setStep = (index: number, patch: Partial<CollectionOrderStep>) => onChange({
        ...agreement,
        collectionOrder: agreement.collectionOrder.map((step, i) => (i === index ? { ...step, ...patch } : step)),
    });

    return (
        <div className="overflow-hidden rounded-lg border border-gray-200 dark:border-slate-700">
            <table className="w-full text-sm">
                <thead className="bg-slate-50 text-left dark:bg-slate-800/60">
                    <tr>
                        <th className="px-4 py-2 font-semibold text-gray-700 dark:text-gray-200">Ordem de cobrança</th>
                        <th className="px-4 py-2">
                            <span className="block font-semibold text-gray-700 dark:text-gray-200">Antes do vencimento</span>
                            <span className="text-xs font-normal text-gray-500">{hasPreventive ? preventiveLabel(policy.schedules.preventive) : 'A política não cobra nesta fase'}</span>
                        </th>
                        <th className="px-4 py-2">
                            <span className="block font-semibold text-gray-700 dark:text-gray-200">Depois do vencimento</span>
                            <span className="text-xs font-normal text-gray-500">{hasOverdue ? overdueLabel(policy.schedules.overdue) : 'A política não cobra nesta fase'}</span>
                        </th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-slate-700">
                    {agreement.collectionOrder.map((step, index) => (
                        <tr key={step.role}>
                            <td className="px-4 py-3 text-gray-800 dark:text-gray-100">{index + 1}. {ROLE_LABEL[step.role]}</td>
                            <td className="px-4 py-3">
                                <ToogleSwitch ariaLabel={`${ROLE_LABEL[step.role]} antes do vencimento`} disabled={!hasPreventive}
                                    checked={step.preventive && hasPreventive} onChange={preventive => setStep(index, { preventive })} />
                            </td>
                            <td className="px-4 py-3">
                                <ToogleSwitch ariaLabel={`${ROLE_LABEL[step.role]} depois do vencimento`} disabled={!hasOverdue}
                                    checked={step.overdue && hasOverdue} onChange={overdue => setStep(index, { overdue })} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CollectionOrderTable;
